// https://uicolors.app/create

type ColorShadesType = {
    '0': string,
    '50': string,
    '100': string,
    '200': string,
    '300': string,
    '400': string,
    '500': string,
    '600': string,
    '700': string,
    '800': string,
    '900': string,
    '950': string,
    '1000': string,
};

const rawColors: {
    [key: string]: Omit<ColorShadesType, '0' | '1000'>,
} = {
    'raw-umber': {
        '50': '#fcfbea',
        '100': '#f8f6c9',
        '200': '#f2eb96',
        '300': '#ead95a',
        '400': '#e2c52d',
        '500': '#d2ae20',
        '600': '#b58a19',
        '700': '#916417',
        '800': '#754e1a',
        '900': '#67431c',
        '950': '#3c230c',
    },
    'loulou': {
        '50': '#fff3fe',
        '100': '#ffe7fe',
        '200': '#ffcefc',
        '300': '#ffa7f8',
        '400': '#ff72f2',
        '500': '#f83de7',
        '600': '#dc1dc8',
        '700': '#b714a2',
        '800': '#951383',
        '900': '#7a156a',
        '950': '#560048',
    },

    'red-ribbon': {
        '50': '#fef2f2',
        '100': '#fee6e5',
        '200': '#fccfcf',
        '300': '#f9a8a8',
        '400': '#f57779',
        '500': '#ec474f',
        '600': '#dc3545',
        '700': '#b7192c',
        '800': '#99182c',
        '900': '#83182c',
        '950': '#490812',
    },
    'emerald': {
        '50': '#f0fdf5',
        '100': '#dcfce8',
        '200': '#bbf7d1',
        '300': '#86efad',
        '400': '#4ade80',
        '500': '#22c55e',
        '600': '#16a34a',
        '700': '#15803c',
        '800': '#166533',
        '900': '#14532b',
        '950': '#052e14',
    },
    'dove-gray': {
        '50': '#f6f6f6',
        '100': '#e7e7e7',
        '200': '#d1d1d1',
        '300': '#b0b0b0',
        '400': '#888888',
        '500': '#737373',
        '600': '#5d5d5d',
        '700': '#4f4f4f',
        '800': '#454545',
        '900': '#3d3d3d',
        '950': '#262626',
    },
    'athens-gray': {
        '50': '#f6f7f8',
        '100': '#edeff2',
        '200': '#d9dee4',
        '300': '#bfc6d1',
        '400': '#a0abba',
        '500': '#8994a8',
        '600': '#778199',
        '700': '#6b728a',
        '800': '#5a5f73',
        '900': '#4b4f5d',
        '950': '#30333b',
    },

}

const colors: {
    [key: string]: ColorShadesType,
} = {}
for (const key in rawColors) {
    const color = rawColors[key]

    colors[key] = {
        ...color,
        '0': '#FFFFFF',
        '1000': '#000000',
    }
}

// const resolveIndex = (
//     index: number
// ): number => {
//     if (index > 10 || index < 0) {
//         throw new Error(`Invalid index ${index}`)
//     }
//
//     let real: number;
//
//     if (index === 0) {
//         real = 0.5
//     } else if (index === 10) {
//         real = 9.5
//     } else {
//         real = index
//     }
//
//     real = real * 100
//
//     return real
// }

// const getColor = (
//     palette: ColorShadesType,
//     index: ColorIndexType
// ): string => {
//     // const real = resolveIndex(index)
//     // return palette[real as keyof ColorShadesType]
//
//     return palette[index]
// }

// type ColorIndexType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
type ColorIndexType = number

// const contrasts = {
//     50: 900,
//     100: 900,
//     200: 900,
//     300: 900,
//     400: 100,
//     500: 100,
//     600: 100,
//     700: 100,
//     800: 100,
//     900: 100,
//     950: 100,
// }

export type {
    ColorShadesType,
    ColorIndexType,
}

export {
    colors,
    // contrasts,
    // resolveIndex,
    // getColor
}
